module.exports = __webpack_public_path__ + "img/bg.c2fd8c9d.jpg";